/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    array, bool, func, object,
} from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Slider from 'react-slick';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import styles from './BGSReviewsStyles';

/* eslint-disable react/jsx-props-no-spreading */
const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <button type="button" className="nextArrow" style={{ boxShadow: 'none', outline: 'none' }} onClick={onClick}> {/* eslint-disable-line */}
            <i className="material-icons text-icon"><ArrowForwardIosIcon /></i>
        </button>
    );
};
NextArrow.propTypes = {
    onClick: func,
};

NextArrow.defaultProps = {
    onClick: () => {},
};

const PrevArrow = (props) => {
    const { onClick } = props;

    return (
        <button type="button" className="prevArrow" style={{ boxShadow: 'none', outline: 'none' }} onClick={onClick}> {/* eslint-disable-line */}
            <ArrowBackIosIcon className="material-icons text-icon" />
        </button>
    );
};
PrevArrow.propTypes = {
    onClick: func,
};

PrevArrow.defaultProps = {
    onClick: () => {},
};

const BGSReviews = (props) => {
    const { isSmallScreen, slider, classes } = props;
    console.log('[+] isSmallScreen:', isSmallScreen);
    const content = slider;
    const isSliderEnabled = content.length <= 4 ? false : true; {/* eslint-disable-line */}

    const settings = {
        dots: false,
        infinite: isSliderEnabled,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        currentSlide: 0,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 850,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <div className={`${classes.bgsReviewsWrapper} bgsReviewsSlider bgs-review-slider`}>
                <Slider {...settings}>
                    {content.map((item) => (
                        <div key={item.uid}>
                            <img className="image bgsReview" src={item.url} alt={item.title} key={item.uid} />
                        </div>
                    ))}
                </Slider>
            </div>
        </>
    );
};

BGSReviews.propTypes = {
    isSmallScreen: bool,
    classes: object.isRequired,
    onClick: func,
    slider: array.isRequired,
};

BGSReviews.defaultProps = {
    onClick: () => {},
    isSmallScreen: false,
};

export default withStyles(styles)(BGSReviews);
